export function getMainScrollElement() {
  return document.documentElement;
}

export function scrollPageToTop() {
  window.scrollTo({ top: 0 });
}
